import { createAction } from 'redux-actions'
import { createLoadingAction } from 'utils/actions'

let prefix = 'INFLUENCERS/'

export const influencersRequestError = createAction(`${prefix}INFLUENCERS_REQUEST_ERROR`)
export const influencersRequestStart = createAction(`${prefix}INFLUENCERS_REQUEST_START`)
export const influencersRequestSuccess = createAction(`${prefix}INFLUENCERS_REQUEST_SUCCESS`)
export const moreInfluencersRequestError = createAction(`${prefix}MORE_INFLUENCERS_REQUEST_ERROR`)
export const moreInfluencersRequestStart = createAction(`${prefix}MORE_INFLUENCERS_REQUEST_START`)
export const moreInfluencersRequestSuccess = createAction(`${prefix}MORE_INFLUENCERS_REQUEST_SUCCESS`)
export const exportInfluencersXlsxStart = createLoadingAction(`${prefix}EXPORT_INFLUENCERS_XLSX_START`, true)
export const exportInfluencersXlsxSuccess = createLoadingAction(`${prefix}EXPORT_INFLUENCERS_XLSX_SUCCESS`, false)
export const exportInfluencersXlsxError = createLoadingAction(`${prefix}EXPORT_INFLUENCERS_XLSX_ERROR`, false)
export const searchForInfluencer = createAction(`${prefix}SEARCH_FOR_INFLUENCER`)

export const setSortBy = createAction(`${prefix}SET_SORT_BY`)

export const selectInfluencer = createAction(`${prefix}SELECT_INFLUENCER`)
export const resetInfluencerSelection = createAction(`${prefix}RESET_INFLUENCER_SELECTION`)

export const openAddInfluencerToContactsDialog = createAction(`${prefix}OPEN_ADD_INFLUENCER_TO_CONTACTS_DIALOG`)
export const closeAddInfluencerToContactsDialog = createAction(`${prefix}CLOSE_ADD_INFLUENCER_TO_CONTACTS_DIALOG`)
export const addInfluencerToContactsStart = createAction(`${prefix}ADD_INFLUENCER_TO_CONTACTS_START`)
export const addInfluencerToContactsSuccess = createAction(`${prefix}ADD_INFLUENCER_TO_CONTACTS_SUCCESS`)
export const addInfluencerToContactsError = createAction(`${prefix}ADD_INFLUENCER_TO_CONTACTS_ERROR`)
export const updateContactData = createAction(`${prefix}UPDATE_CONTACT_DATA`)
export const setDistributionListCreateDialogOpen = createAction(`${prefix}SET_DISTRIBUTION_LIST_CREATE_DIALOG_OPEN`)

// CAUTION: this is the request which is fetching from the new people index 'leude'
export const fetchInfluencerStart = createAction(`${prefix}FETCH_INFLUENCER_START`)
export const fetchInfluencerSuccess = createAction(`${prefix}FETCH_INFLUENCER_SUCCESS`)
export const fetchInfluencerError = createAction(`${prefix}FETCH_INFLUENCER_ERROR`)

prefix = `${prefix}/DETAIL/`

export const showInfluencerDetails = createAction(`${prefix}SHOW_INFLUENCER_DETAILS`)
export const hideInfluencerDetails = createAction(`${prefix}HIDE_INFLUENCER_DETAILS`)

// CAUTION: this is the request which is fetching people from the current index groot_authors
export const fetchInfluencerRequestError = createAction(`${prefix}FETCH_INFLUENCER_REQUEST_ERROR`)
export const fetchInfluencerRequestStart = createAction(`${prefix}FETCH_INFLUENCER_REQUEST_START`)
export const fetchInfluencerRequestSuccess = createAction(`${prefix}FETCH_INFLUENCER_REQUEST_SUCCESS`)

export const selectChannel = createAction(`${prefix}SELECT_CHANNEL`)
export const highlightReachChart = createAction(`${prefix}HIGHLIGHT_REACH_CHART`)
